import { RootState } from "@/modules/common";

export const selectPaymentProviderOptions = (state: RootState) =>
  state.customers.paymentProviderOptions.filter(x => x.allowed);
